// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2Ieer","card":"Cards_card__3123Y","infected":"Cards_infected__1smtJ","recovered":"Cards_recovered__1tdHT","deaths":"Cards_deaths__3XAC1"};